import { useState } from "react";

import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import type { Rdo } from "../../types.ts";

export const OBSERVATIONS_MAX_LENGTH = 4000;

interface ObservationsSectionProps {
	rdo: Rdo;
	readOnly: boolean;
	onChange: (value: string) => void;
}

export function ObservationsSection({
	rdo,
	readOnly,
	onChange,
}: ObservationsSectionProps) {
	const [value, setValue] = useState(rdo.observations);
	return (
		<section className="rdo-editor__section" aria-labelledby="rdo-observations">
			<h2 id="rdo-observations" className="rdo-editor__section-title">
				Observações
			</h2>
			<div className="rdo-editor__field">
				<Label htmlFor="rdo-observations-input" className="visually-hidden">
					Observações
				</Label>
				<Textarea
					id="rdo-observations-input"
					className="rdo-editor__textarea"
					placeholder="Ocorrências, impedimentos, visitas, entregas…"
					value={value}
					maxLength={OBSERVATIONS_MAX_LENGTH}
					disabled={readOnly}
					onChange={(event) => {
						setValue(event.target.value);
						onChange(event.target.value);
					}}
				/>
				<span className="rdo-editor__counter">
					{value.length}/{OBSERVATIONS_MAX_LENGTH}
				</span>
			</div>
		</section>
	);
}
